import SettingsSection from '../components/Settings/SettingsSection'
import UserTable from '../components/user/UserTable'
import useUsers from '../hooks/useUsers'

import OffCanvas from '../components/Shared/OffCanvas'
import useOffCanvas from '../hooks/useOffCanvas'
import { AnimatePresence, motion } from 'framer-motion'

import useModal from '../hooks/useModal'
import Modal from '../components/Shared/Modal'

import UserView from '../components/user/UserView'

const Users = () => {
  const { allUsers, loading } = useUsers()

  const { isOpen, config, open, close } = useOffCanvas()

  const {
    isOpen: isModalOpen,
    modalConfig,
    closeModal,
    isLargeModal,
  } = useModal()

  const selectedUser = (user) => {
    open('Detalle de Usuario', <UserView user={user} />)
  }

  return (
    <div className="users-module">
      {/* CAPA DE MODALES Y OFFCANVAS */}
      <div>
        {/* OFFCANVAS - Con Overlay Slate */}
        <AnimatePresence>
          {isOpen && (
            <motion.div
              key="offcanvas-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="custom-offcanvas-overlay"
            >
              <OffCanvas isOpen={isOpen} onClose={close} title={config.title}>
                <motion.div
                  key="offcanvas-content"
                  initial={{ x: 100, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: 100, opacity: 0 }}
                  transition={{ type: 'spring', damping: 25, stiffness: 200 }}
                >
                  {config.component}
                </motion.div>
              </OffCanvas>
            </motion.div>
          )}
        </AnimatePresence>

        {/* MODAL - Con Escala Suave */}
        <AnimatePresence>
          {isModalOpen && (
            <motion.div
              key="modal-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <Modal
                isOpen={isModalOpen}
                onClose={closeModal}
                title={modalConfig.title}
                isLarge={isLargeModal}
              >
                <motion.div
                  key="modal-content"
                  initial={{ scale: 0.9, opacity: 0, y: 20 }}
                  animate={{ scale: 1, opacity: 1, y: 0 }}
                  exit={{ scale: 0.9, opacity: 0, y: 20 }}
                  transition={{ duration: 0.2 }}
                >
                  {modalConfig.component}
                </motion.div>
              </Modal>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <SettingsSection
        title="Usuarios"
        icon="fa-users"
        description="Accesos y perfiles de las personas que usan el sistema."
        actions={
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => alert('Abrir formulario de creación')}
          >
            <i className="fa-solid fa-user-plus me-2" />
            Nuevo usuario
          </button>
        }
      >
        <UserTable
          users={allUsers}
          loading={loading}
          selectedUser={selectedUser}
        />
      </SettingsSection>
    </div>
  )
}

export default Users
